const i = {
  list: "list",
  pair: "pair",
  single: "single"
};
export {
  i as CalendarVariants
};
